import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOrganization } from "@clerk/clerk-react";
import { client, handleClientMethod } from "../client";

export const useCreateCustomPart = () => {
  const { organization } = useOrganization();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { title: string; cost: number }) => {
      return await handleClientMethod(
        client.POST("/api/custom-parts", {
          body: data,
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/api/custom-parts", organization?.id],
      });
    },
  });
};
